export default __webpack_public_path__ + "static/media/loader.ed371782.svg";